import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from './home.service';
import { UserService } from '../shared';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'home-page',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  searchText = '';
  searchingData = false;
  constructor(
    private router: Router,
    private userService: UserService,
    private homeService: HomeService,
      public toastr: ToastsManager, vcr: ViewContainerRef,
  ) { }

  isAuthenticated: boolean;

  ngOnInit() {
    this.userService.isAuthenticated.subscribe(
      (authenticated) => {
        this.isAuthenticated = authenticated;
        if (authenticated) {
          // do something here
        } else {
          // do something else here
        }
      }
    );

  }

  SearchLead() {
    this.searchingData = true;
    console.log(this.searchText);
    let date = {
      'searchKeyword': this.searchText
    }

    this.homeService.searchLead(date).subscribe((template) => {
      this.searchingData = false;
      if (template.length > 0) {
        this.router.navigateByUrl('lead/my-lead?searchText=' + this.searchText);
      }
      else{
        this.toastr.error("No records found.");
      }
    }, error => {
      this.searchingData = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts